import { useContext } from 'react';
import Modal from '@/Modal';
import ModalContext from '~/contexts/ModalContext';
import HollowPlugIcon from '~/icons/HollowPlugIcon';
import { Content, EVCreditPillContainer } from './EVTaxCreditModal.styles';
import EVTaxCreditContent from '../../EVTaxCreditContent/EVTaxCreditContent';

export default function EVTaxCreditModal() {
  const { isEVTaxCreditModalOpen, setEVTaxCreditModalOpen } =
    useContext(ModalContext);

  const onClose = () => {
    setEVTaxCreditModalOpen(false);
  };

  return (
    <Modal
      headerText="EV Tax Credit"
      open={isEVTaxCreditModalOpen}
      onToggle={onClose}
      whiteBg
    >
      <Content data-qa="ev-tax-modal-card">
        <EVTaxCreditContent
          headerTag={
            <EVCreditPillContainer>
              <HollowPlugIcon />
              EV Tax Credit
            </EVCreditPillContainer>
          }
          qualificationCopy="Vehicles with the ‘EV Credit’ badge may qualify for the Previously-Owned Clean Vehicle tax credit made available to taxpayers in the Inflation Reduction Act."
          showAdditionalInfo
        />
      </Content>
    </Modal>
  );
}
